import script from "./ViewPaymentVoucherPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPaymentVoucherPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewPaymentVoucherPage.vue?vue&type=style&index=0&id=73067741&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73067741"]])

export default __exports__